var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-block"},[_c('div',{staticClass:"add-block__added-damage-text"}),_c('p-button',{staticClass:"p-button-sm",attrs:{"label":"Добавить повреждение","disabled":_vm.buttonIsDisabled},on:{"click":_vm.addDamage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }